export const governmentFooterBannerContent = {
  heading: 'The time for transformation is now',
  description:
    'The digital era keeps accelerating. Cultivating digital talent within national borders is a surefire strategy for economic advancement.',
  primaryButtonLabel: 'Learn More',
};

export const governmentFooterBannerBackgroundImages = {
  mobile: '/images/backgrounds/footer-banner-bg-mobile.png',
  desktop: '/images/backgrounds/footer-banner-bg.png',
};
